import axios from 'axios'
import caseConverter from '../utils/case-converter'

const token = document.querySelector('[name=csrf-token]').content

function transformConfig(transform) {
  if (!transform) return {};

  return {
    transformRequest: [
      (data) => caseConverter (data, 'decamelize'),
      ...(axios.defaults.transformRequest),
    ],
    transformResponse: [
      ...(axios.defaults.transformResponse),
      (data) => caseConverter (data, 'camelize'),
    ],
  };
}

export default({ transform = false } = {}) => {

  return axios.create({
    withCredentials: true,
    baseURL: '/',
    headers: {
      'X-CSRF-Token': token,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    ...transformConfig(transform)
  })
}
